import fetchExpresso from 'utility/fetchExpresso';

export async function getCompProducts(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/comp-products`);

    if (response.status !== 200) {
        throw new Error('failed to load comp products');
    }

    return response.json();
}

export async function getCompRegistrationForm(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/registration/registration-form`);

    if (response.status !== 200) {
        throw new Error('failed to load comp registration form');
    }

    return response.json();
}

export async function getSeatChannels(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/seat-channels`);

    if (response.status !== 200) {
        throw new Error('failed to load seat channels');
    }

    const { channelKeys } = await response.json();

    return channelKeys;
}

export async function createCompOrder(eventId, orderPayload) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/orders/`, {
        method: 'POST',
        body: orderPayload,
    });

    if (response.status !== 200) {
        const data = await response.json().catch(() => null);
        const error = new Error('failed to create comp order');

        if (data?.code === 'season_capacity_exceeded') {
            error.userMessage =
                'There is not enough season admission capacity.';
        }

        throw error;
    }

    return response.json();
}

export async function releaseHoldToken(eventId, holdToken) {
    try {
        const response = await fetchExpresso(`/apiv2/events/${eventId}/release-hold`, {
            method: 'POST',
            body: { holdToken },
        });

        if (response.status === 200) {
            const { success } = await response.json();
            if (success === true) {
                return { success };
            }
        } else {
            throw new Error('hold token was not released');
        }
    } catch (e) {
        throw e;
    }
}
